
import { Vue, Component, Prop, PropSync } from "vue-property-decorator";
import ImageInput from "@/components/base/form/ImageInput.vue";
import { uploadToS3 } from "@/api";
import { IOfferProduct } from "@/api/types/offers";
import { EDITABLE_LOGO_PRODUCT_IDS } from "@/mappings/offer";

@Component({
    components: { ImageInput },
})

export default class FormLogo extends Vue {
    @PropSync('product') productSync!: IOfferProduct;
    @Prop({ required: true }) isEdit!: boolean;
    @Prop({ required: true }) param!: any;

    get isEditable(): boolean {
        return this.isEdit && EDITABLE_LOGO_PRODUCT_IDS.includes(this.productSync.product.id);
    }

    async updateLogo(e: any): Promise<void> {
        const { data } = await uploadToS3(e);
        if (data?.url) {
            this.productSync.params[this.param.param] = data.url;
        }
    }
}
